module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Hi there! We're an awesome group of creatives from a variety of different\nbackgrounds with a variety of skills.")]), _c('section', {
    staticClass: "team"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("TEAM")]), _vm._l((_vm.products), function(product, index) {
    return (index < 8) ? _c('div', {
      staticClass: "gallery-product"
    }, [_c('h2', {
      staticClass: "person-name"
    }, [_vm._v("Ipsum Lorem")]), _c('span', {
      staticClass: "person-prof"
    }, [_vm._v("Ipsum Lorem")]), _c('p', {
      staticClass: "person-description"
    }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do\neiusmod tempor incididunt ut labore et dolore magna aliqua.")]), _c('div', {
      staticClass: "product-img"
    }, [_c('img', {
      attrs: {
        "src": product.url,
        "alt": "product.name"
      }
    })])]) : _vm._e()
  })], 2), _c('section', {
    staticClass: "awards"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("AWARDS")]), _vm._l((4), function(n) {
    return _c('div', {
      staticClass: "awards-item"
    }, [_c('img', {
      attrs: {
        "src": require("../../assets/index/award-logo.svg"),
        "alt": "Awwwwards"
      }
    })])
  })], 2), _c('section', {
    staticClass: "clients"
  }, [_c('h2', {
    staticClass: "aside-title"
  }, [_vm._v("CLIENTS")]), _vm._l((2), function(n) {
    return _c('div', {
      staticClass: "clients-row"
    }, _vm._l((4), function(n) {
      return _c('div', {
        staticClass: "clients-item"
      }, [_c('img', {
        attrs: {
          "src": require("../../assets/index/award-logo.svg"),
          "alt": "Awwwwards"
        }
      })])
    }))
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7b39b0d7"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/About.vue
// module id = 131
// module chunks = 0